import { Component, Vue, Prop } from "vue-property-decorator";
import { Modal } from "ant-design-vue";
import { InvitationTemplateService } from "@/services/invitation-template-service";
import { IPreviewModel } from "@/models/content-admin/invitation-preview-model";
import RichTextEditor from "@/components/rich-text-editor/rich-text-editor.vue";
import { ContentAdminLocale } from "@/locales/localeid";
import { fmtMsg } from "@/commonui/utils";

@Component({
	components: { Modal, RichTextEditor }
})
export default class InvitationPreview extends Vue {
	@Prop({ default: null }) unloadPreview: any;
	@Prop({ default: false }) visible!: boolean;
	@Prop({ default: null }) preview!: IPreviewModel;

	public subject = "";
	public htmlContent = "";
	public isTemplateDataLoaded = false;

	created() {
		this.renderInvitationTemplate();
	}

	localizedString(id: string, params?: {}) {
		return fmtMsg(id, params);
	}

	get contentAdminLocales() {
		return ContentAdminLocale;
	}

	handlePreviewCancel() {
		this.$emit("unloadPreview");
	}

	renderInvitationTemplate() {
		const params = {
			invitationType: 14,
			referenceId: null,
			templateId: this.preview?.templateId,
			name: this.preview?.userName,
			email: this.preview?.userEmail
		};

		InvitationTemplateService.previewInvitationTemplate(params)
			.then((data: any) => {
				this.isTemplateDataLoaded = true;
				this.subject = data.title;
				this.htmlContent = data.text;
			})
			.catch((error) => {
				this.isTemplateDataLoaded = false;
			});
	}
}
